import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateRange } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { date } from '@rxweb/reactive-form-validators';
import axios from 'axios';
import { data } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-caneperzonebygroup',
  templateUrl: './caneperzonebygroup.component.html',
  styleUrls: ['./caneperzonebygroup.component.css']
})
export class CaneperzonebygroupComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  @ViewChild('table2') table2: ElementRef;
  @ViewChild('table3') table3: ElementRef;
  @ViewChild('table4') table4: ElementRef;

  today: string;
  Dayform: UntypedFormGroup;
  constructor(private spinner: NgxSpinnerService, private router: Router) {
    this.Dayform = new UntypedFormGroup({
      selectday1: new UntypedFormControl(),
      selectday2: new UntypedFormControl(),
      selecttype: new UntypedFormControl(),
      zone: new UntypedFormControl(),
    });
    let options: any = { year: '2-digit', month: 'short', day: 'numeric' };
    let oneday = new Date();
    this.today = oneday.toLocaleDateString('th-TH', options);
  }

  ngOnInit(): void {
    //this.Loadtopbar();
    this.change_tap23(0);
    this.LoadZone();
  }

  datein1 = { date1: new Date('2025-12-1'), date2: new Date(Date.now()) }
  topbardata = [0, 0, 0, 0, 0, 0];

  ExportExcel(id: any) {
    if (id == 1) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${this.textshow1}.xlsx`);
    }
    else if (id == 2) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table2.nativeElement);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${this.textshow1}.xlsx`);
    }
    else if (id == 3) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table3.nativeElement);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${this.textshow1}.xlsx`);
    }
    else if (id == 4) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table4.nativeElement);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${this.textshow1}.xlsx`);
    }
    /* save to file */
  }

  texttap = 0;
  textshow1: string
  topbardata1: number[] = [];
  change_tap23(data: number) {
    this.caneperdaygroup = [];
    this.texttap = data
    if (data == 0) {
      this.textshow1 = 'ปริมาณอ้อยเข้าหีบรายโซนประจำวัน'
      this.caneperdaygroup = []
    }
    else if (data == 1) {
      this.textshow1 = 'ปริมาณอ้อยเข้าหีบรายโซนประจำวัน ตามกลุ่มในโซน'
      this.caneperdaygroup = this.caneperdaygroup1
    }
    else if (data == 2) {
      this.textshow1 = 'ปริมาณอ้อยเข้าหีบรายโซนประจำวัน ตามรูทในโซน'
      this.caneperdaygroup = this.caneperdaygroup2
    }
    else if (data == 3) {
      this.textshow1 = 'ปริมาณอ้อยเข้าหีบรายนสส ตามรูทในแปลง'
      this.caneperdaygroup = this.caneperdaygroup2
    }
    else if (data == 4) {
      this.textshow1 = 'ประเมินอ้อยใหม่31ม.ค. รายนสส'
      this.caneperdaygroup_n = this.CaneperdaybySV_n[1]
      this.topbardata1[0] = this.topbardata[4]
    }
    else if (data == 5) {
      this.textshow1 = 'ประเมินอ้อยใหม่17ก.พ. รายนสส'
      this.caneperdaygroup_n = this.CaneperdaybySV_n[2]
      this.topbardata1[0] = this.topbardata[5]
    }
  }

  loader = [false, false, false, false];

  year_n = [2626, 6869, '68/69']
  // โหลดข้อมูล zone  zonecode: any[];
  zonecode: any[];
  LoadZone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/zoneGroup";
    axios.get(url)
      .then(res => {
        this.zonecode = (res.data.recordset);
        this.spinner.hide();
      }).catch(err => { throw (err) })
    this.spinner.hide();
  }


  // รวมค่าข้างล่าง
  sumallbygroup: any[];
  sumdata(data: any) {
    this.sumallbygroup = [];

    this.sumallbygroup = [{
      'sumassess': (data.map((el: any) => { return parseFloat(el.assess) })).reduce((a, b) => a + b, 0),
      'sumcanein': (data.map((el: any) => { return parseFloat(el.canein) })).reduce((a, b) => a + b, 0),
      'sumcaneleft': (data.map((el: any) => { return parseFloat(el.caneleft) })).reduce((a, b) => a + b, 0),
      'sumccs_be': (data.map((el: any) => { return parseFloat(el.ccs_be) })).reduce((a, b) => a + b, 0) / data.length,
      'sumcanetargetDate': (data.map((el: any) => { return parseFloat(el.canetargetDate) })).reduce((a, b) => a + b, 0),
      'sumcaneindate': (data.map((el: any) => { return parseFloat(el.caneindate) })).reduce((a, b) => a + b, 0),
      'sumcanewaitbrr': (data.map((el: any) => { return parseFloat(el.canewaitbrr) })).reduce((a, b) => a + b, 0),
      'sumcanein_be': (data.map((el: any) => { return parseFloat(el.canein_be) })).reduce((a, b) => a + b, 0),
    }];
  }
  caneperdaygroup1 = [];
  caneperdaygroup2 = [];

  caneperdaygroup_n = [];
  // โหลดข้อมูลอ้อยรายวันประจำโซน
  caneperdayzone = [];
  LoadCaneperdaybyzone() {
    let day1 = this.date2en(this.datein1.date1) //this.date2en(this.Dayform.get('selectday1').value);
    let day2 = this.date2en(this.datein1.date2)//this.date2en(this.Dayform.get('selectday2').value);
    this.choosedate = this.date2th(day1) + " - " + this.date2th(day2);
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].cpcDiarysupzone&v='${day1}','${day2}'`;
    //this.spinner.show();
    this.loader[0] = true;
    axios.get(url)
      .then(res => {
        //this.spinner.hide();
        this.loader[0] = false;
        let data = res.data.recordset;
        if (data.length == 0) {
          alert("ไม่มีข้อมูลวันนี้");
        }
        else {
          this.caneperdayzone = data;
          data = data.filter((el: any) => el.Partcode == "BRD");
          this.topbardata[0] = data[0].pccanecollect;
        }
      }).catch(err => {
        throw (err)
      })
  }

  caneperdaygroup = [];
  choosedate = 'วันที่เลือก';
  LoadCaneperdaybygroup() {
    let url = '', txtto = '';
    let day1 = this.date2en(this.datein1.date1);
    let day2 = this.date2en(this.datein1.date2);
    let type = this.texttap//(this.Dayform.get('selecttype').value);
    this.choosedate = this.date2th(day1) + " - " + this.date2th(day2);
    if (type == 1) {
      txtto = '[cpcDiaryzone_group]';
    }
    else if (type == 2) {
      txtto = '[cpcDiaryzone_route]';
    }
    else ''
    url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].${txtto}&v='${day1}','${day2}'`;
    this.caneperdaygroup = [];
    this.loader[0] = true;
    axios.get(url)
      .then(res => {
        //this.spinner.hide();
        this.loader[0] = false;
        let data = res.data.recordset
        if (data.length == 0) { alert("ไม่มีข้อมูลวันนี้"); }
        else {
          if (this.texttap == 1) {
            this.caneperdaygroup1 = data;
            this.caneperdaygroup = data;
          }
          else if (this.texttap == 2) {
            this.caneperdaygroup2 = data;
            this.caneperdaygroup = data;
          }
          data = data.filter((el: any) => el.Partcode == "BRD");
          this.topbardata[1] = data[0].pccanecollect_1601;
        }
      }).catch(err => {
        throw (err)
      });
  }

  caneperdaySV = [];
  LoadCaneperdaybySV() {
    let url = '', txtto = '';
    let day1 = this.date2en(this.datein1.date1);
    let day2 = this.date2en(this.datein1.date2);
    let type = this.texttap//(this.Dayform.get('selecttype').value);
    this.choosedate = this.date2th(day1) + " - " + this.date2th(day2);
    url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].[cpcDiarySupcode_route]&v='${day1}','${day2}'`;
    this.caneperdaySV = [];
    this.loader[0] = true;
    axios.get(url)
      .then(res => {
        this.loader[0] = false;
        let data = res.data.recordset
        if (data.length == 0) { alert("ไม่มีข้อมูลวันนี้"); }
        else {
          this.caneperdaySV = data;
          data = data.filter((el: any) => el.Partcode == "BRD");
          this.topbardata[3] = data[0].pccanecollect;
        }
      }).catch(err => {
        throw (err)
      });
  }

  CaneperdaybySV_n = [];
  LoadCaneperdaybySV_n() {
    let type = this.texttap//(this.Dayform.get('selecttype').value);
    let url = '', txtto = '';
    let day1 = this.date2en(this.datein1.date1);
    let day2 = this.date2en(this.datein1.date2);
    this.choosedate = this.date2th(day1) + " - " + this.date2th(day2);
    if (type == 4) {
      txtto = '[cpcDiarySupcode_route_n]';
      this.CaneperdaybySV_n[1] = [];
    }
    else if (type == 5) {
      txtto = '[cpcDiarySupcode_route_n2]';
      this.CaneperdaybySV_n[2] = [];
    }
    else ''
    url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/exec_f_v?f=[dbQBRD].[dbo].${txtto}&v='${day1}','${day2}'`;

    this.loader[0] = true;
    axios.get(url)
      .then(res => {
        this.loader[0] = false;
        let data = res.data.recordset
        if (data.length == 0) { alert("ไม่มีข้อมูลวันนี้"); }
        else {
          if (type == 4) {
            this.CaneperdaybySV_n[1] = data;
            data = data.filter((el: any) => el.Partcode == "BRD");
            this.topbardata[4] = data[0].pccanecollect;
            this.change_tap23(4);
          }
          else if (type == 5) {
            this.CaneperdaybySV_n[2] = data;
            data = data.filter((el: any) => el.Partcode == "BRD");
            this.topbardata[5] = data[0].pccanecollect;
            this.change_tap23(5);
          }
        }
      }).catch(err => {
        throw (err)
      });
  }


  //formatDate
  // แปลงวันที่
  date2en(date: Date) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "2-digit", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('sv-SE', options);
  }

  date2th(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit"//, hour: "2-digit", minute: "2-digit", timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  Toint(data: any) {
    let toint = data.toLocaleString('ar-TH');
    return parseInt(toint);
  }
}